module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.$route.path !== '/login' && _vm.$route.path !== '/otp' && _vm.$route.path !== '/register') ? _c('header', {
    staticClass: "app-header navbar"
  }, [_c('span', {
    staticClass: "navbar-brand",
    attrs: {
      "to": "/"
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav"
  }, [_vm._m(0), _vm._v(" "), (_vm.$root.userRole === 'admin' || _vm.$root.userRole === 'purchaser' || _vm.$root.userRole === 'qc' || _vm.$root.userRole === 'r_and_d' || _vm.$root.userRole === 'client' || _vm.$root.userRole === 'client_p' || _vm.$root.userRole === 'hq_top' || _vm.$root.userRole === 'hq_warehouse') ? _c('span', [(_vm.$root.userRole !== 'client' && _vm.$root.userRole !== 'qc') ? [_c('li', {
    staticClass: "nav-item dropdown px-1"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu dropdown-menu-right"
  }, [_c('router-link', {
    staticClass: "dropdown-item",
    attrs: {
      "to": "/backlog"
    }
  }, [_c('img', {
    staticClass: "iconx backlogicon",
    attrs: {
      "src": "/static/images/icons/backlog.png"
    }
  }), _vm._v(" Backlog\n\t\t                \t")]), _vm._v(" "), (_vm.$root.userRole == 'admin') ? _c('router-link', {
    staticClass: "dropdown-item",
    attrs: {
      "target": "_blank",
      "to": "/backlog/sales-order/add"
    }
  }, [_c('img', {
    staticClass: "iconx backlogicon",
    attrs: {
      "src": "/static/images/icons/cashback.svg"
    }
  }), _vm._v(" New Sales Order\n\t\t                    ")]) : _vm._e(), _vm._v(" "), (_vm.$root.userRole != 'client_p' && _vm.$root.userRole != 'hq_top' && _vm.$root.userRole != 'r_and_d' && _vm.$root.userRole != 'hq_warehouse') ? _c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.showPurchaseOrderModal = true
      }
    }
  }, [_c('img', {
    staticClass: "iconx backlogicon",
    attrs: {
      "src": "/static/images/icons/bill.png"
    }
  }), _vm._v(" \n\t\t                    \tNew Purchase Order\n\t\t                    ")]) : _vm._e(), _vm._v(" "), (_vm.$root.userRole != 'client_p' && _vm.$root.userRole != 'hq_top' && _vm.$root.userRole != 'r_and_d' && _vm.$root.userRole != 'hq_warehouse') ? _c('router-link', {
    staticClass: "dropdown-item",
    attrs: {
      "target": "_blank",
      "to": "/payment-plan/add"
    }
  }, [_c('img', {
    staticClass: "iconx backlogicon",
    attrs: {
      "src": "/static/images/icons/dollar2.png"
    }
  }), _vm._v(" \n\t\t\t\t\t\t\t\tPayment Plan Submission\n\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.$root.userRole != 'client_p' && _vm.$root.userRole != 'hq_top' && _vm.$root.userRole != 'r_and_d' && _vm.$root.userRole != 'hq_warehouse') ? _c('router-link', {
    staticClass: "dropdown-item",
    attrs: {
      "target": "_blank",
      "to": "/arrival-details/add"
    }
  }, [_c('img', {
    staticClass: "iconx backlogicon",
    attrs: {
      "src": "/static/images/icons/delivery-box.png"
    }
  }), _vm._v(" \n\t\t\t\t\t\t\t\tArrival Details Submission\n\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.$root.user_role == 'admin' || _vm.$root.userRole == 'client_p' || _vm.$root.userRole == 'hq_top') ? _c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.showHqDeliveryDateChangeModal = true
      }
    }
  }, [_c('img', {
    staticClass: "iconx backlogicon",
    attrs: {
      "src": "/static/images/icons/clock.png"
    }
  }), _vm._v(" \n\t\t                    Change HQ delivery date")]) : _vm._e()], 1)])] : _vm._e(), _vm._v(" "), (_vm.$root.userRole != 'hq_warehouse') ? _c('li', {
    staticClass: "nav-item dropdown px-1"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu dropdown-menu-right"
  }, [_c('router-link', {
    staticClass: "dropdown-item",
    attrs: {
      "to": "/items"
    }
  }, [_c('img', {
    staticClass: "iconx backlogicon",
    attrs: {
      "src": "/static/images/icons/item.png"
    }
  }), _vm._v(" Items")]), _vm._v(" "), (!_vm.$root.isClient && !_vm.$root.isHqTop && !_vm.$root.isRandD && !_vm.$root.isQc) ? _c('router-link', {
    staticClass: "dropdown-item",
    attrs: {
      "to": "/quotations"
    }
  }, [_c('img', {
    staticClass: "iconx backlogicon",
    attrs: {
      "src": "/static/images/icons/dollar.png"
    }
  }), _vm._v(" Quotations")]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "dropdown-item",
    attrs: {
      "to": "/vendors"
    }
  }, [_c('img', {
    staticClass: "iconx backlogicon",
    attrs: {
      "src": "/static/images/icons/vendor.png"
    }
  }), _vm._v(" Vendors")]), _vm._v(" "), (!_vm.$root.isPurchaser && !_vm.$root.isQc && !_vm.$root.isRandD) ? [(_vm.$root.isClient || _vm.$root.isHqTop) ? _c('router-link', {
    staticClass: "dropdown-item",
    attrs: {
      "to": "/client/commercial-offers"
    }
  }, [_c('img', {
    staticClass: "iconx backlogicon",
    attrs: {
      "src": "/static/images/icons/business.png"
    }
  }), _vm._v(" Commercial Offers")]) : _c('router-link', {
    staticClass: "dropdown-item",
    attrs: {
      "to": "/auth-commercial-offers"
    }
  }, [_c('img', {
    staticClass: "iconx backlogicon",
    attrs: {
      "src": "/static/images/icons/business.png"
    }
  }), _vm._v(" Commercial Offers")])] : _vm._e(), _vm._v(" "), (!_vm.$root.isRandD) ? _c('router-link', {
    staticClass: "dropdown-item",
    attrs: {
      "to": "/qr-management"
    }
  }, [_c('img', {
    staticClass: "iconx backlogicon",
    attrs: {
      "src": "/static/images/icons/quality_assurance.png"
    }
  }), _vm._v(" QR Management")]) : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), (_vm.$root.userRole === 'admin' || _vm.$root.userRole === 'supervisor' || _vm.$root.userRole === 'client' || _vm.$root.userRole === 'client_p' || _vm.$root.userRole === 'purchaser' || _vm.$root.userRole === 'qc' || _vm.$root.userRole === 'r_and_d' || _vm.$root.userRole === 'hq_top') ? _c('li', {
    staticClass: "nav-item px-1"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/samples-documents"
    }
  }, [_c('img', {
    staticClass: "iconx documentsicon",
    attrs: {
      "src": "/static/images/icons/icon-documents.png"
    }
  }), _vm._v(" Documents/Samples/RFQ")])], 1) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "nav-item dropdown px-1"
  }, [(_vm.$root.user.user_type === 'admin' || _vm.$root.isHqTop) ? _c('a', {
    staticClass: "nav-link dropdown-toggle nav-link",
    attrs: {
      "href": "",
      "data-toggle": "dropdown",
      "role": "button",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_c('img', {
    staticClass: "iconx accounticon",
    attrs: {
      "src": "/static/images/icons/icon-system.png"
    }
  }), _vm._v("System")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu dropdown-menu-right"
  }, [_c('router-link', {
    staticClass: "dropdown-item",
    attrs: {
      "to": "/users"
    }
  }, [_c('img', {
    staticClass: "iconx usericon",
    attrs: {
      "src": "/static/images/icons/user.png"
    }
  }), _vm._v(" User Management\n\t\t\t\t\t\t\t")]), _vm._v(" "), (_vm.$root.anAdmin) ? [_c('router-link', {
    staticClass: "dropdown-item",
    attrs: {
      "to": "/clients"
    }
  }, [_c('img', {
    staticClass: "iconx usericon",
    attrs: {
      "src": "/static/images/icons/costumer.png"
    }
  }), _vm._v(" Clients")])] : _vm._e(), _vm._v(" "), (_vm.$root.anAdmin) ? [_c('router-link', {
    staticClass: "dropdown-item",
    attrs: {
      "to": "/settings"
    }
  }, [_c('img', {
    staticClass: "iconx usericon",
    attrs: {
      "src": "/static/images/icons/settings.png"
    }
  }), _vm._v(" Settings")])] : _vm._e()], 2)]), _vm._v(" "), (_vm.$root.anAdmin || _vm.$root.userRole === 'auditor') ? _c('li', {
    staticClass: "nav-item px-1"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/documents-archive"
    }
  }, [_c('img', {
    staticClass: "iconx documentsicon",
    attrs: {
      "src": "/static/images/icons/document-archive.png"
    }
  }), _vm._v(" Documents Archive")])], 1) : _vm._e()], 2) : _c('span', [(_vm.$root.isCommercialOffer()) ? _c('li', {
    staticClass: "nav-item px-1"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/buyersheet"
    }
  }, [_c('i', {
    staticClass: "fa fa-shopping-cart",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Buyer Sheet")])], 1) : _vm._e()])]), _vm._v(" "), (_vm.$route.path != '/commercial-offers') ? _c('ul', {
    staticClass: "nav navbar-nav pull-right"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    staticStyle: {
      "margin-right": "20px"
    },
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_vm._v("Welcome "), _c('b', [_vm._v(_vm._s(_vm.$root.userName))]), _vm._v("!")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item dropdown px-1"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu dropdown-menu-right"
  }, [(_vm.$root.anAdmin) ? _c('router-link', {
    staticClass: "dropdown-item",
    attrs: {
      "to": "/change-password"
    }
  }, [_c('i', {
    staticClass: "fa fa-lock"
  }), _vm._v(" Change Password\n\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.logout
    }
  }, [_c('i', {
    staticClass: "fa fa-lock"
  }), _vm._v(" Logout")])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.$route.path == '/commercial-offers') ? _c('ul', {
    staticClass: "nav navbar-nav pull-right"
  }, [_vm._m(4)]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.showPurchaseOrderModal) ? _c('modal', {
    on: {
      "close": function($event) {
        _vm.showPurchaseOrderModal = false
      }
    }
  }, [_c('h5', {
    staticStyle: {
      "margin-bottom": "0"
    },
    slot: "header"
  }, [_vm._v("New Purchase Order Registration")]), _vm._v(" "), _c('div', {
    slot: "body"
  }, [_c('purchase-order')], 1), _vm._v(" "), _c('span', {
    slot: "support"
  })]) : _vm._e(), _vm._v(" "), (_vm.showHqDeliveryDateChangeModal) ? _c('modal', {
    staticClass: "hq-delivery-date-change",
    on: {
      "close": function($event) {
        _vm.showHqDeliveryDateChangeModal = false
      }
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "0"
    },
    slot: "header"
  }, [_c('h5', [_c('img', {
    staticClass: "image-50",
    attrs: {
      "src": "/static/images/icons/clock.png"
    }
  }), _vm._v(" "), _c('b', [_vm._v("HQ delivery date change registration")])])]), _vm._v(" "), _c('div', {
    slot: "body"
  }, [_c('hq-delivery-date-change')], 1), _vm._v(" "), _c('span', {
    slot: "support"
  })]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "nav-item dropdown px-1",
    attrs: {
      "id": "hk-logo"
    }
  }, [_c('span', {
    staticClass: "nav-link logo-link",
    staticStyle: {
      "color": "#fff",
      "font-weight": "700",
      "font-style": "italic"
    },
    attrs: {
      "href": ""
    }
  }, [_c('img', {
    staticClass: "iconx backlogicon",
    staticStyle: {
      "width": "60px",
      "height": "50px"
    },
    attrs: {
      "src": "/static/images/icons/hongkong.png"
    }
  }), _vm._v("\n\t\t    \t\t\t Hong Kong\n\t\t    \t\t")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "nav-link dropdown-toggle active",
    attrs: {
      "href": "",
      "data-toggle": "dropdown",
      "role": "button",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_c('img', {
    staticClass: "iconx backlogicon",
    attrs: {
      "src": "/static/images/icons/icon-backlog.png"
    }
  }), _vm._v(" Backlog")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "nav-link dropdown-toggle nav-link",
    attrs: {
      "href": "",
      "data-toggle": "dropdown",
      "role": "button",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_c('img', {
    staticClass: "iconx inventoryicon",
    attrs: {
      "src": "/static/images/icons/icon-inventory.png"
    }
  }), _vm._v("Inventory")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "nav-link dropdown-toggle nav-link",
    attrs: {
      "data-toggle": "dropdown",
      "href": "#",
      "role": "button",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_c('span', {
    staticClass: "d-md-down-none"
  }, [_c('i', {
    staticClass: "icon-user icons"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "nav-item px-1"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "/#login"
    }
  }, [_vm._v("Login")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-43c3657a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = 271
// module chunks = 89